

import React, { useState, useEffect } from "react";
import AxiosInstance from "../../../AxiosInstance";
import { formatXaf, formatEurFromXaf } from "../../../utils/currency";

const ServiceForm = ({
    cities,
    categories,
    showModal,
    currentServiceId,
    setCurrentServiceId,
    editingServiceId,
    setEditingServiceId,
    serviceEtapes,
    loadServiceEtapes,
    safeSetState,
    isMountedRef,
    setTab,
    serviceToEdit,
    setServiceToEdit,
    setServiceEtapes
}) => {
    const [arrondissements, setArrondissements] = useState([]);
    const [showLocationForm, setShowLocationForm] = useState(false);
    const [showEtapeSection, setShowEtapeSection] = useState(false);
    const [editingLocationIndex, setEditingLocationIndex] = useState(null);

    const [form, setForm] = useState({
        title: "",
        description: "",
        varies_by_arrondissement: false,
        average_time: "",
        estimated_cost: "",
        is_badge: false,
        category: "",
        locations: [],
        pricing_data: []
    });

    const [currentLocation, setCurrentLocation] = useState({
        cityId: "",
        arrondissementIds: [],
        pricing: {
            pricing_type: "fixed",
            base_price: "",
            full_price: "",
            estimated_duration: ""
        }
    });

    // Charger les données à éditer
    useEffect(() => {
        if (serviceToEdit && editingServiceId) {
            const fullService = serviceToEdit;

            setForm({
                title: fullService.service.title || "",
                description: fullService.service.description || "",
                varies_by_arrondissement: fullService.service.varies_by_arrondissement || false,
                average_time: fullService.service.average_time || "",
                estimated_cost: fullService.service.estimated_cost || "",
                is_badge: fullService.service.is_badge || false,
                category: fullService.service.id_TypeOfCategory?._id || fullService.service.category?._id || fullService.service.category || "",
                locations: fullService.locations || [],
                pricing_data: fullService.pricing_data || []
            });

            setShowEtapeSection(true);
            setServiceToEdit(null);
        }
    }, [serviceToEdit, editingServiceId, setServiceToEdit]);

    // Charger les arrondissements d’une ville sélectionnée
    useEffect(() => {
        if (currentLocation.cityId) {
            const fetchArrondissements = async () => {
                try {
                    const res = await AxiosInstance.get(`/api/cities/${currentLocation.cityId}/arrondissements`);
                    if (isMountedRef.current) {
                        safeSetState(setArrondissements, res.data.arrondissements || res.data || []);
                    }
                } catch (error) {
                    console.error("Erreur lors du chargement des arrondissements:", error);
                    if (isMountedRef.current) safeSetState(setArrondissements, []);
                }
            };
            fetchArrondissements();
        }
    }, [currentLocation.cityId, isMountedRef, safeSetState]);

    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
    };

    const handleCurrentLocationChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name.startsWith("pricing.")) {
            const pricingField = name.split(".")[1];
            setCurrentLocation(prev => ({
                ...prev,
                pricing: {
                    ...prev.pricing,
                    [pricingField]: type === "checkbox" ? checked : value
                }
            }));
        } else if (name === "arrondissementIds") {
            const arrId = value;
            setCurrentLocation(prev => ({
                ...prev,
                arrondissementIds: checked
                    ? [...prev.arrondissementIds, arrId]
                    : prev.arrondissementIds.filter(id => id !== arrId)
            }));
        } else {
            setCurrentLocation(prev => ({ ...prev, [name]: value }));
        }
    };

    // Supprimer la fonction startEditService du ServiceForm car elle est maintenant dans App

    const validateLocations = (locations, pricingData) => {
        const seen = new Set();

        for (let i = 0; i < locations.length; i++) {
            const location = locations[i];
            const cityKey = location.cityId || 'all';
            const arrKey = location.arrondissementIds?.length > 0
                ? location.arrondissementIds.join(',')
                : 'all';
            const key = `${cityKey}_${arrKey}`;

            if (seen.has(key)) {
                throw new Error(`Duplication détectée: Une tarification existe déjà pour cette ville/arrondissement`);
            }
            seen.add(key);
        }

        return true;
    };

    // const addLocation = () => {
    //     if (!currentLocation.cityId) {
    //         showModal("Veuillez sélectionner une ville");
    //         return;
    //     }

    //     if (!currentLocation.pricing.base_price || !currentLocation.pricing.full_price) {
    //         showModal("Veuillez saisir les prix");
    //         return;
    //     }

    //     const newLocations = [...form.locations];
    //     const newPricingData = [...form.pricing_data];

    //     const locationData = {
    //         cityId: currentLocation.cityId,
    //         arrondissementIds: currentLocation.arrondissementIds
    //     };

    //     const pricingData = {
    //         cityId: currentLocation.cityId,
    //         arrondissementId: currentLocation.arrondissementIds.length > 0 ? currentLocation.arrondissementIds[0] : null,
    //         pricing: { ...currentLocation.pricing }
    //     };

    //     if (editingLocationIndex !== null) {
    //         newLocations[editingLocationIndex] = locationData;
    //         newPricingData[editingLocationIndex] = pricingData;
    //         setEditingLocationIndex(null);
    //         showModal("Localisation modifiée avec succès !");
    //     } else {
    //         if (currentLocation.arrondissementIds.length > 0) {
    //             currentLocation.arrondissementIds.forEach(arrId => {
    //                 newPricingData.push({
    //                     cityId: currentLocation.cityId,
    //                     arrondissementId: arrId,
    //                     pricing: { ...currentLocation.pricing }
    //                 });
    //             });
    //             newLocations.push({
    //                 cityId: currentLocation.cityId,
    //                 arrondissementIds: currentLocation.arrondissementIds
    //             });
    //         } else {
    //             newPricingData.push({
    //                 cityId: currentLocation.cityId,
    //                 arrondissementId: null,
    //                 pricing: { ...currentLocation.pricing }
    //             });
    //             newLocations.push({
    //                 cityId: currentLocation.cityId,
    //                 arrondissementIds: []
    //             });
    //         }
    //         showModal("Localisation ajoutée avec succès !");
    //     }

    //     setForm(prev => ({
    //         ...prev,
    //         locations: newLocations,
    //         pricing_data: newPricingData
    //     }));

    //     setCurrentLocation({
    //         cityId: "",
    //         arrondissementIds: [],
    //         pricing: {
    //             pricing_type: "fixed",
    //             base_price: "",
    //             full_price: "",
    //             estimated_duration: ""
    //         }
    //     });
    //     setShowLocationForm(false);
    // };

    // const editLocation = (index) => {
    //     const location = form.locations[index];
    //     const pricing = form.pricing_data[index];

    //     setCurrentLocation({
    //         cityId: location.cityId || "",
    //         arrondissementIds: location.arrondissementIds || [],
    //         pricing: {
    //             pricing_type: pricing?.pricing?.pricing_type || pricing?.pricing_type || "fixed",
    //             base_price: pricing?.pricing?.base_price || pricing?.base_price || "",
    //             full_price: pricing?.pricing?.full_price || pricing?.full_price || "",
    //             estimated_duration: pricing?.pricing?.estimated_duration || pricing?.estimated_duration || ""
    //         }
    //     });

    //     setEditingLocationIndex(index);
    //     setShowLocationForm(true);
    // };

    const addLocation = () => {
        if (!currentLocation.cityId) return showModal("Veuillez sélectionner une ville");
        if (!currentLocation.pricing.base_price || !currentLocation.pricing.full_price) return showModal("Veuillez saisir les prix");

        let newLocations = [...form.locations];
        let newPricingData = [...form.pricing_data];

        const locationData = {
            cityId: currentLocation.cityId,
            arrondissementIds: currentLocation.arrondissementIds
        };

        if (editingLocationIndex !== null) {
            // *** MODIFICATION ICI : Supprimer les anciens pricing_data de cette location ***
            const oldLocation = newLocations[editingLocationIndex];

            if (oldLocation?.arrondissementIds?.length > 0) {
                // Supprimer tous les pricing correspondant aux arrondissements de l'ancienne location
                newPricingData = newPricingData.filter(pd => {
                    // Garder seulement les pricing qui ne sont PAS dans les anciens arrondissements
                    return !oldLocation.arrondissementIds.includes(pd.arrondissementId);
                });
            } else {
                // Supprimer le pricing de toute la ville
                newPricingData = newPricingData.filter(pd =>
                    !(pd.cityId === oldLocation.cityId && pd.arrondissementId === null)
                );
            }

            // *** MODIFICATION ICI : Ajouter les NOUVEAUX pricing_data ***
            if (currentLocation.arrondissementIds.length > 0) {
                // Créer un pricing pour CHAQUE arrondissement sélectionné
                currentLocation.arrondissementIds.forEach(arrId => {
                    newPricingData.push({
                        cityId: currentLocation.cityId,
                        arrondissementId: arrId,
                        pricing: {
                            pricing_type: currentLocation.pricing.pricing_type,
                            base_price: parseFloat(currentLocation.pricing.base_price),
                            full_price: parseFloat(currentLocation.pricing.full_price),
                            estimated_duration: currentLocation.pricing.estimated_duration
                                ? parseInt(currentLocation.pricing.estimated_duration)
                                : null
                        }
                    });
                });
            } else {
                // Pricing pour toute la ville
                newPricingData.push({
                    cityId: currentLocation.cityId,
                    arrondissementId: null,
                    pricing: {
                        pricing_type: currentLocation.pricing.pricing_type,
                        base_price: parseFloat(currentLocation.pricing.base_price),
                        full_price: parseFloat(currentLocation.pricing.full_price),
                        estimated_duration: currentLocation.pricing.estimated_duration
                            ? parseInt(currentLocation.pricing.estimated_duration)
                            : null
                    }
                });
            }

            newLocations[editingLocationIndex] = locationData;
            setEditingLocationIndex(null);
            showModal("Localisation modifiée avec succès !");

        } else {
            // Nouvelle location - code existant
            newLocations.push(locationData);

            if (currentLocation.arrondissementIds.length > 0) {
                currentLocation.arrondissementIds.forEach(arrId => {
                    newPricingData.push({
                        cityId: currentLocation.cityId,
                        arrondissementId: arrId,
                        pricing: {
                            pricing_type: currentLocation.pricing.pricing_type,
                            base_price: parseFloat(currentLocation.pricing.base_price),
                            full_price: parseFloat(currentLocation.pricing.full_price),
                            estimated_duration: currentLocation.pricing.estimated_duration
                                ? parseInt(currentLocation.pricing.estimated_duration)
                                : null
                        }
                    });
                });
            } else {
                newPricingData.push({
                    cityId: currentLocation.cityId,
                    arrondissementId: null,
                    pricing: {
                        pricing_type: currentLocation.pricing.pricing_type,
                        base_price: parseFloat(currentLocation.pricing.base_price),
                        full_price: parseFloat(currentLocation.pricing.full_price),
                        estimated_duration: currentLocation.pricing.estimated_duration
                            ? parseInt(currentLocation.pricing.estimated_duration)
                            : null
                    }
                });
            }
            showModal("Localisation ajoutée avec succès !");
        }

        setForm(prev => ({
            ...prev,
            locations: newLocations,
            pricing_data: newPricingData
        }));

        setCurrentLocation({
            cityId: "",
            arrondissementIds: [],
            pricing: { pricing_type: "fixed", base_price: "", full_price: "", estimated_duration: "" }
        });
        setShowLocationForm(false);
    };


    const editLocation = (index) => {
        const location = form.locations[index];

        // Trouver TOUS les pricing_data correspondant à cette location
        let relevantPricingData = [];

        if (location.arrondissementIds && location.arrondissementIds.length > 0) {
            // Si la location a des arrondissements spécifiques, chercher tous les pricing correspondants
            relevantPricingData = form.pricing_data.filter(pd =>
                pd.cityId === location.cityId &&
                location.arrondissementIds.includes(pd.arrondissementId)
            );
        } else {
            // Si c'est pour toute la ville
            relevantPricingData = form.pricing_data.filter(pd =>
                pd.cityId === location.cityId &&
                pd.arrondissementId === null
            );
        }

        // Prendre le premier pricing comme référence (ils devraient tous être identiques)
        const pricing = relevantPricingData[0] || {};

        setCurrentLocation({
            cityId: location.cityId || "",
            arrondissementIds: location.arrondissementIds || [],
            pricing: {
                pricing_type: pricing?.pricing?.pricing_type || pricing?.pricing_type || "fixed",
                base_price: pricing?.pricing?.base_price || pricing?.base_price || "",
                full_price: pricing?.pricing?.full_price || pricing?.full_price || "",
                estimated_duration: pricing?.pricing?.estimated_duration || pricing?.estimated_duration || ""
            }
        });

        setEditingLocationIndex(index);
        setShowLocationForm(true);
    };


    const removeLocation = (index) => {
        const newLocations = form.locations.filter((_, i) => i !== index);
        const removedLocation = form.locations[index];
        let newPricingData = form.pricing_data.filter(pd => {
            if (removedLocation.arrondissementIds.length > 0) {
                return !removedLocation.arrondissementIds.includes(pd.arrondissementId);
            } else {
                return !(pd.cityId === removedLocation.cityId && pd.arrondissementId === null);
            }
        });

        setForm(prev => ({
            ...prev,
            locations: newLocations,
            pricing_data: newPricingData
        }));
    };

    // const validateLocations = (locations, pricingData) => {
    //     const seen = new Set();
    //     for (let i = 0; i < locations.length; i++) {
    //         const location = locations[i];
    //         const cityKey = location.cityId || "all";
    //         const arrKey = location.arrondissementIds?.length > 0
    //             ? location.arrondissementIds.join(",")
    //             : "all";
    //         const key = `${cityKey}_${arrKey}`;
    //         if (seen.has(key)) throw new Error(`Duplication détectée pour la ville/arrondissement`);
    //         seen.add(key);
    //     }
    //     return true;
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation des locations
        try {
            validateLocations(form.locations, form.pricing_data);
        } catch (error) {
            showModal(error.message);
            return;
        }

        if (form.locations.length === 0) {
            showModal("Veuillez ajouter au moins une localisation pour le service");
            return;
        }

        try {
            if (editingServiceId) {
                // Modification d'un service existant
                await AxiosInstance.put(`/api/services/${editingServiceId}`, {
                    ...form,
                    id_TypeOfCategory: form.category,
                });
                showModal("Service modifié avec succès !");

                // Réinitialisation après un petit délai pour laisser le temps au message
                setTimeout(() => {
                    resetForm();
                }, 500);

            } else {
                // Création d'un nouveau service
                const response = await AxiosInstance.post(`/api/services`, {
                    ...form,
                    id_TypeOfCategory: form.category,
                });

                const createdServiceId = response?.data?.service?._id || response?.data?._id || response?.data?.id || null;

                if (createdServiceId) {
                    setCurrentServiceId(createdServiceId);
                    setShowEtapeSection(true);

                    // Afficher le message de confirmation
                    showModal("Service créé avec succès ! Vous pouvez maintenant ajouter des étapes.");

                    // Réinitialiser le formulaire après un petit délai (500ms)
                    setTimeout(() => {
                        resetForm();
                    }, 500);
                } else {
                    // Cas où le backend renvoie une réponse inattendue
                    showModal("Service créé avec succès ! Vous pouvez maintenant ajouter des étapes.");
                    setTimeout(() => {
                        resetForm();
                    }, 500);
                }
            }
        } catch (err) {
            console.error("Erreur création/modification :", err);

            // Gestion spécifique des doublons de tarification
            if (err.response?.data?.error?.includes('E11000') ||
                err.response?.data?.message?.includes('duplicate') ||
                err.response?.status === 409) {
                showModal("Erreur: Une tarification existe déjà pour cette combinaison ville/arrondissement.");
            } else {
                showModal("Erreur lors de la création ou modification du service.");
            }
        }
    };


    const resetForm = () => {
        setForm({
            title: "",
            description: "",
            varies_by_arrondissement: false,
            average_time: "",
            estimated_cost: "",
            is_badge: false,
            category: "",
            locations: [],
            pricing_data: []
        });
        setEditingServiceId(null);
        setCurrentServiceId(null);
        setServiceEtapes([]);
        setShowEtapeSection(false);
        setEditingLocationIndex(null);
        setShowLocationForm(false);
        setServiceToEdit(null);
        setCurrentLocation({
            cityId: "",
            arrondissementIds: [],
            pricing: { pricing_type: "fixed", base_price: "", full_price: "", estimated_duration: "" }
        });
    };



    return (
        <form onSubmit={handleSubmit} className="tab-content active">
            <h2>
                <strong className="label-black">
                    {editingServiceId ? "Modifier le Service" : "Créer un Nouveau Service"}
                </strong>
            </h2>

            <div className="form-grid">
                <div className="form-group">
                    <label>Titre *</label>
                    <input
                        name="title"
                        value={form.title}
                        onChange={handleFormChange}
                        className="form-control"
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Catégorie *</label>
                    <select
                        name="category"
                        value={form.category}
                        onChange={handleFormChange}
                        className="form-control"
                        required
                    >
                        <option value="">Sélectionner</option>
                        {Array.isArray(categories) && categories.map(cat => (
                            <option key={cat._id} value={cat._id}>{cat.title}</option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="form-group">
                <label>Description *</label>
                <textarea
                    name="description"
                    value={form.description}
                    onChange={handleFormChange}
                    className="form-control"
                    required
                />
            </div>

            <div className="form-grid">
                <div className="form-group">
                    <label>Temps Moyen (jours)</label>
                    <input
                        name="average_time"
                        value={form.average_time}
                        onChange={handleFormChange}
                        className="form-control"
                        placeholder="ex: 2-3"
                    />
                </div>
                <div className="form-group">
                    <label>Coût Estimé</label>
                    <input
                        name="estimated_cost"
                        value={form.estimated_cost}
                        onChange={handleFormChange}
                        className="form-control"
                        placeholder="ex: 50-100 EUR"
                    />
                </div>
            </div>

            <div className="checkbox-group">
                <label>
                    <input
                        type="checkbox"
                        name="varies_by_arrondissement"
                        checked={form.varies_by_arrondissement}
                        onChange={handleFormChange}
                    />
                    Le service varie selon l'arrondissement
                </label>
                <label>
                    <input
                        type="checkbox"
                        name="is_badge"
                        checked={form.is_badge}
                        onChange={handleFormChange}
                    />
                    Service avec badge
                </label>
            </div>

            <div className="section-divider">
                <h3><strong className="label-black">Localisations et Tarification</strong></h3>

                {form.locations.length > 0 && (
                    <div className="locations-list">
                        <h4>Localisations ajoutées :</h4>
                        {form.locations.map((location, index) => {
                            const city = cities.find(c => c._id === location.cityId);
                            const pricing = form.pricing_data[index];

                            return (
                                <div key={index} className="location-card">
                                    <div className="location-info">
                                        <strong>{city?.name || "Ville inconnue"}</strong>
                                        {location.arrondissementIds && location.arrondissementIds.length > 0 ? (
                                            <span> - Arrondissements spécifiques ({location.arrondissementIds.length})</span>
                                        ) : (
                                            <span> - Toute la ville</span>
                                        )}
                                        <br />
                                        <small>
                                            Prix: {formatXaf(pricing?.pricing?.base_price ?? pricing?.base_price)} ({formatEurFromXaf(pricing?.pricing?.base_price ?? pricing?.base_price)}) - {formatXaf(pricing?.pricing?.full_price ?? pricing?.full_price)} ({formatEurFromXaf(pricing?.pricing?.full_price ?? pricing?.full_price)})
                                        </small>
                                    </div>
                                    <div style={{ display: "flex", gap: "5px" }}>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-warning"
                                            onClick={() => editLocation(index)}
                                        >
                                            ✏️ Modifier
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger"
                                            onClick={() => removeLocation(index)}
                                        >
                                            🗑️ Supprimer
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        setCurrentLocation({
                            cityId: "",
                            arrondissementIds: [],
                            pricing: {
                                pricing_type: "fixed",
                                base_price: "",
                                full_price: "",
                                estimated_duration: ""
                            }
                        });
                        setEditingLocationIndex(null);
                        setShowLocationForm(!showLocationForm);
                    }}
                >
                    {showLocationForm ? "Annuler" : "Ajouter une localisation"}
                </button>

                {showLocationForm && (
                    <div className="location-form">
                        <h4>{editingLocationIndex !== null ? "Modifier la localisation" : "Nouvelle localisation"}</h4>

                        <div className="form-grid">
                            <div className="form-group">
                                <label>Ville *</label>
                                <select
                                    name="cityId"
                                    value={currentLocation.cityId}
                                    onChange={handleCurrentLocationChange}
                                    className="form-control"
                                    required
                                >
                                    <option value="">Sélectionner</option>
                                    {Array.isArray(cities) && cities.map(c =>
                                        <option key={c._id} value={c._id}>{c.name}</option>
                                    )}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Type de tarification</label>
                                <select
                                    name="pricing.pricing_type"
                                    value={currentLocation.pricing.pricing_type}
                                    onChange={handleCurrentLocationChange}
                                    className="form-control"
                                >
                                    <option value="fixed">Prix fixe</option>
                                    <option value="hourly">Par heure</option>
                                    <option value="per_unit">Par unité</option>
                                    <option value="per_m2">Par m²</option>
                                    <option value="negotiable">Négociable</option>
                                </select>
                            </div>
                        </div>

                        {form.varies_by_arrondissement && Array.isArray(arrondissements) && arrondissements.length > 0 && (
                            <div className="form-group">
                                <label>Arrondissements (optionnel - laissez vide pour toute la ville)</label>
                                <div className="checkbox-grid">
                                    {arrondissements.map(arr => (
                                        <label key={arr._id} className="checkbox-item">
                                            <input
                                                type="checkbox"
                                                name="arrondissementIds"
                                                value={arr._id}
                                                checked={currentLocation.arrondissementIds.includes(arr._id)}
                                                onChange={handleCurrentLocationChange}
                                            />
                                            {arr.name}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="form-grid">
                            <div className="form-group">
                                <label>Prix de base FCFA (XAF) ( Cout WEMAZA ) *</label>
                                <input
                                    name="pricing.base_price"
                                    type="number"
                                    value={currentLocation.pricing.base_price}
                                    onChange={handleCurrentLocationChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Prix final avec charges FCFA (XAF) ( Cout WEMAZA avec TVA ) *</label>
                                <input
                                    name="pricing.full_price"
                                    type="number"
                                    value={currentLocation.pricing.full_price}
                                    onChange={handleCurrentLocationChange}
                                    className="form-control"
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Durée estimée (Heure)</label>
                            <input
                                name="pricing.estimated_duration"
                                type="number"
                                value={currentLocation.pricing.estimated_duration}
                                onChange={handleCurrentLocationChange}
                                className="form-control"
                            />
                        </div>

                        <button type="button" className="btn btn-primary" onClick={addLocation}>
                            {editingLocationIndex !== null ? "Modifier cette localisation" : "Ajouter cette localisation"}
                        </button>
                    </div>
                )}
            </div>

            <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
                <button type="submit" className="btn btn-primary">
                    {editingServiceId ? "💾 Enregistrer les modifications" : "Créer le Service"}
                </button>

                {editingServiceId && (
                    <button type="button" className="btn btn-secondary" onClick={resetForm}>
                        Annuler
                    </button>
                )}
            </div>
        </form>
    );
};

export default ServiceForm;

